import { sonataToplineMeta } from "../../sonata-topline-meta/src/widget";
import { sonataControlData } from "../../sonata-control-data/src/widget";

// ! rename the function to align with the widget name
export const sonataMetaShare = async () => {
    const el = document.querySelector('.curious-sonata-meta-share');
    if (!el) return;

    // ------------------------------------------------------------
    const endpoint = el.getAttribute('data-endpoint');
    if (!endpoint) {
        console.error('No endpoint specified for the sonata-topline-meta widget');
        return;
    }
    const url = `${window.apiUri}${endpoint}`
    try {
        const response = await fetch(url)
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`)
        }
        const data = await response.json();
   
        //! RUN WIDGET FUNCTIONS THAT RELY ON GENERIC DATA
        sonataToplineMeta(data)
        sonataControlData(data)

        console.log(data)
        const loadingStates = document.querySelectorAll('.curious-sonata-control-data, .curious-sonata-topline-meta')
        loadingStates.forEach(container => container.classList.remove('loading'))


    } catch(error) {
        console.error(error.message)
    }
   

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

